import request from "../utils/request";

export const get = (id) => request.get(`/api/article/${id}`);
export const list = (data) => request.get("/api/article", data);
export const create = (data) => request.post("/api/article", data);
export const update = (id, data) => request.put(`/api/article/${id}`, data);
export const remove = (id) => request.del(`/api/article/${id}`);